module.exports = __webpack_public_path__ + "img/3.31958c8b.png";